<template>
    <el-form :rules="rules" label-position="top" ref="form" :model="data">
        <el-row>
            <el-col>
                <el-form-item label="配置名称" prop="item_name">
                    <el-input type="textarea" v-model="data.item_name" maxlength='100'></el-input>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="配置项" prop="item_uuid">
                    <el-select filterable v-model="data.item_uuid" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.id" :label="item.text" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="配置模版" prop="item_conf">
                    <el-input type="textarea" v-model="data.item_conf" rows='6' maxlength='2000'></el-input>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="备注" prop="opcomment">
                    <el-input type="textarea" v-model="data.opcomment" rows='4' maxlength='200'></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
    import MouldApi from "./Mould";

    export default {
        props: {
            dat: {}
        },
        data() {
            var validateInput = (rule, value, callback) => {
                if (!this.checkSpecificKey(value)) {
                    callback(new Error("存在特殊字符"));
                } else {
                    callback();
                }
            };
            return {
                data: {
                    uuid: "",
                    item_uuid: "",
                    item_name: "",
                    item_conf: "",
                    opcomment: ""
                },
                options: [],
                rules: {
                    item_name: [
                        {required: true, message: "请输入配置名称"},
                        {validator: validateInput, trigger: ["blur", "change"]},
                        {min: 1, max: 50, message: "长度在 1 到 50 个字符以内", trigger: "blur"}
                    ],
                    item_uuid: [{required: true, message: "请选择配置项"}],
                    item_conf: [
                        {required: true, message: "请输入配置模板"},
                        {validator: validateInput, trigger: ["blur", "change"]},
                        {min: 1, max: 1000, message: "长度在 1 到 1000 个字符以内", trigger: "blur"}
                    ],
                    opcomment: [
                        {min: 0, max: 100, message: "长度在 0 到 100 个字符以内", trigger: "blur"}
                    ]
                }
            };
        },
        // 当前组件显示到页面之后立即执行，（挂载到页面）
        mounted() {
            this.loadInfo();
        },
        watch: {
            dat: function () {
                this.loadInfo();
            }
        },
        methods: {
            checkSpecificKey(str) {
                let specialKey = "`~!#$^&=|''\\\\.<>/?~！#￥……&（）——|【】‘；”“'。，、？‘'";
                for (var i = 0; i < str.length; i++) {
                    if (specialKey.indexOf(str.substr(i, 1)) != -1) {
                        return false;
                    }
                }
                return true;
            },
            loadInfo() {
                this.$refs["form"].resetFields();
                this.data.uuid = this.dat.uuid;
                this.data.item_name = this.dat.itemname;
                this.data.item_conf = this.dat.itemconf;
                this.data.item_uuid = this.dat.itemuuid;
                this.data.opcomment = this.dat.opcomment;
                MouldApi.getlistItem().then(data => {
                    this.options = data.listItem;
                });
                if (!this.dat.uuid) {
                    this.data.item_name = "";
                    this.data.item_conf = "";
                    this.data.item_uuid = "";
                }
            },
            async saveMould() {
                await this.$refs["form"].validate();
                if (this.data.uuid) {
                    await MouldApi.updateJsonMould(this.data);
                } else {
                    await MouldApi.saveMould(this.data);
                }
                this.$emit("upd", "");
            }
        }
    };
</script>

<style>
</style>
